Postlogin = (function (my) {
    Postlogin.AssessmentsDetailsReport = {};
    const me = Postlogin.AssessmentsDetailsReport;

    me.$reportResultsTable = $('#report-results-table');
    me.reportUrl = $('#report-select').find('option[value="AssessmentsDetailsReport"]').data('report-url');
    me.exportUrl = $('#report-select').find('option[value="AssessmentsDetailsReport"]').data('report-export-url');

    me.filters = [
        'user-license-ids',
        'search-date',
        'assigned-by',
        'subtitle',
        'search-user-name',
        'search-first-name',
        'search-last-name',
        'user-groups-single',
        'user-grades',
    ];

    me.setup = function () {
        $('.filter-column').each((index, element) => {
            const thisFilter = $(element);
            if (me.filters.includes(thisFilter.data('filter-name'))) {
                thisFilter.removeClass('hide');
            } else {
                thisFilter.addClass('hide');
            }
        });

        $('.search-date').find('.help-block').text('Limits the results for the assignment dates.');
        me.initEvents();

        me.$reportResultsTable.bootstrapTable('destroy');
        $('#report-toolbar').hide();
    };

    me.runReport = function () {
        me.$reportResultsTable.addClass('sorting');
        me.$reportResultsTable.bootstrapTable('destroy');
        me.$reportResultsTable.bootstrapTable(tableOptions);

        $('#report-toolbar').show();
    };

    me.exportReport = function () {
        const opts = $('#report-results-table').bootstrapTable('getOptions');
        const exportParams = me.getReportParams({
            columns: _.map($('#report-results-table').bootstrapTable('getVisibleColumns'), (col) => col.field),
            offset: 0,
            sort: opts.sortName,
            order: opts.sortOrder,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${me.exportUrl}?${queryString}`, '_blank');
    };

    me.initEvents = function () {
        //
    };

    me.getReportParams = function (params) {
        const searchParams = _.extend({}, params);
        searchParams.license_ids = $('#user-license-ids').val();
        searchParams.date = $('#search-date option:selected').val();
        searchParams.date_range_from = $('#search-start-date').val();
        searchParams.date_range_to = $('#search-end-date').val();
        searchParams.grades = $('#user-grades').val();
        searchParams.username = $('#search-user-name').val();
        searchParams.first_name = $('#search-first-name').val();
        searchParams.last_name = $('#search-last-name').val();
        searchParams.assessment_subtitle = $('#subtitle').val();
        searchParams.assigned_by = $('#assigned-by').val();
        searchParams.completion_status = $('#completion-status').val();
        searchParams.group_id = $('#user-groups-single').val();

        return searchParams;
    };

    const tableOptions = _.extend({}, Jr.reportsDataTable.options, {
        idField: 'user_id',
        url: me.reportUrl,
        toolbar: '#report-toolbar',
        queryParamsType: '',
        queryParams: (params) => me.getReportParams(params),

        onLoadSuccess: (data) => {
            $('time.timeago').timeago();
            me.$reportResultsTable.removeClass('sorting');
            me.$reportResultsTable.closest('.bootstrap-table').find('.pagination-detail .duration').remove();
            me.$reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(`<span class="duration">&nbsp;&nbsp;&nbsp;<em>(query took ${data.duration.toFixed(4)} seconds)</em></span>`);

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();
        },

        columns: [
            {
                title: 'Date Assigned',
                field: 'date_assigned',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                formatter: (value) => {
                    if (value) {
                        return moment(value).format('L');
                    }

                    return '-';
                },
            },
            {
                title: 'Subtitle',
                field: 'subtitle',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: 'Assigned By',
                field: 'assigned_by',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: 'Username',
                field: 'username',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
            },
            {
                title: 'First Name',
                field: 'first_name',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Last Name',
                field: 'last_name',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Date Started',
                field: 'date_started',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: false,
                formatter: (value) => {
                    if (value) {
                        return moment(value).format('L');
                    }

                    return '-';
                },
            },
            {
                title: 'Date Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (value) => {
                    if (value) {
                        return moment(value).format('L');
                    }

                    return '-';
                },
            },
            {
                title: 'Top Cluster 1',
                field: 'top_cluster_1',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Top Cluster 2',
                field: 'top_cluster_2',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Top Cluster 3',
                field: 'top_cluster_3',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Agriculture, Food, Natural Resources',
                field: 'ccisCategory01',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Architecture and Construction',
                field: 'ccisCategory10',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Arts, A/V Technology, and Communications',
                field: 'ccisCategory04',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Business Management and Administration',
                field: 'ccisCategory11',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Education and Training',
                field: 'ccisCategory05',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Energy',
                field: 'ccisCategory07',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Finance',
                field: 'ccisCategory14',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Government and Public Administration',
                field: 'ccisCategory15',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Health Science',
                field: 'ccisCategory06',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Hospitality and Tourism',
                field: 'ccisCategory08',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Human Services',
                field: 'ccisCategory09',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Information Technology',
                field: 'ccisCategory16',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Law & Public Safety',
                field: 'ccisCategory02',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Manufacturing',
                field: 'ccisCategory12',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Marketing, Sales, and Service',
                field: 'ccisCategory17',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Science, Technology, Engineering, Mathematics',
                field: 'ccisCategory13',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
            {
                title: 'Transportation and Logistics',
                field: 'ccisCategory03',
                align: 'center',
                valign: 'middle',
                sortable: false,
            },
        ],
    });

    return my;
}(Postlogin));
